export const TOKEN = "HONOURWORLD_WEBSITE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_LOADING = "LOGOUT_LOADING";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";
export const GET_USER = "GET_USER";
export const GET_USER_FAIL = "GET_USER_FAIL";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const GET_USER_LOADING = "GET_USER_LOADING";

// Data
export const GET_DATA = "GET_DATA";
export const GET_DATA_FAIL = "GET_DATA_FAIL";
export const GET_DATA_DIRECT = "GET_DATA_DIRECT";
export const GET_DATA_DIRECT_FAIL = "GET_DATA_DIRECT_FAIL";
export const GET_DATA_LOADING = "GET_DATA_LOADING";
export const UPDATE_DATA = "UPDATE_DATA";
export const ADD_DATA = "ADD_DATA";
export const ADD_DATA_FAIL = "ADD_DATA_FAIL";
export const GET_CREATE_DATA = "GET_CREATE_DATA";
export const GET_CREATE_DATA_FAIL = "GET_CREATE_DATA_FAIL";
export const CREATE_DATA = "CREATE_DATA";
export const CREATE_DATA_FAIL = "CREATE_DATA_FAIL";
export const DELETE_DATA = "DELETE_DATA";

// Airtime
export const GET_AIRTIME = "GET_AIRTIME";
export const GET_AIRTIME_FAIL = "GET_AIRTIME_FAIL";
export const ADD_AIRTIME = "ADD_AIRTIME";
export const ADD_AIRTIME_FAIL = "ADD_AIRTIME_FAIL";
export const UPDATE_AIRTIME = "UPDATE_AIRTIME";
export const DELETE_AIRTIME = "DELETE_AIRTIME";
export const GET_AIRTIME_LOADING = "GET_AIRTIME_LOADING";

// Education
export const GET_EDUCATION = "GET_EDUCATION";
export const GET_EDUCATION_FAIL = "GET_EDUCATION_FAIL";
export const ADD_EDUCATION = "ADD_EDUCATION";
export const ADD_EDUCATION_FAIL = "ADD_EDUCATION_FAIL";
export const UPDATE_EDUCATION = "UPDATE_EDUCATION";
export const DELETE_EDUCATION = "DELETE_EDUCATION";
export const GET_EDUCATION_LOADING = "GET_EDUCATION_LOADING";

// Electricity
export const GET_ELECTRICITY = "GET_ELECTRICITY";
export const GET_ELECTRICITY_FAIL = "GET_ELECTRICITY_FAIL";
export const GET_ELECTRICITY_DIRECT = "GET_ELECTRICITY_DIRECT";
export const GET_ELECTRICITY_DIRECT_FAIL = "GET_ELECTRICITY_DIRECT_FAIL";
export const UPDATE_ELECTRICITY = "UPDATE_ELECTRICITY";
export const ADD_ELECTRICITY = "ADD_ELECTRICITY";
export const DELETE_ELECTRICITY = "DELETE_ELECTRICITY";
export const GET_ELECTRICITY_LOADING = "GET_ELECTRICITY_LOADING";
export const ADD_ELECTRICITY_FAIL = "ADD_ELECTRICITY_FAIL";

export const GET_CABLE = "GET_CABLE";
export const GET_CABLE_FAIL = "GET_CABLE_FAIL";
export const GET_CABLE_DIRECT_PACKAGE = "GET_CABLE_DIRECT_PACKAGE";
export const GET_CABLE_DIRECT_PACKAGE_FAIL = "GET_CABLE_DIRECT_PACKAGE_FAIL";
export const GET_CABLE_DIRECT_TYPE = "GET_CABLE_DIRECT_TYPE";
export const GET_CABLE_DIRECT_TYPE_FAIL = "GET_CABLE_DIRECT_TYPE_FAIL";
export const UPDATE_CABLE = "UPDATE_CABLE";
export const ADD_CABLE = "ADD_CABLE";
export const DELETE_CABLE = "DELETE_CABLE";
export const GET_CABLE_LOADING = "GET_CABLE_LOADING";
export const ADD_CABLE_FAIL = "ADD_CABLE_FAIL";

export const GET_NETWORK = "GET_NETWORK";
export const GET_NETWORK_FAIL = "GET_NETWORK_FAIL";
export const GET_NETWORK_LOADING = "GET_NETWORK_LOADING";
export const GET_BANKS = "GET_BANKS";
export const GET_BANKS_FAIL = "GET_BANKS_FAIL";

// ERRORS
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const GET_ERRORS_TEXT = "GET_ERRORS_TEXT";

// WALLET
export const GET_WALLET = "GET_WALLET";
export const GET_WALLET_FAIL = "GET_WALLET_FAIL";
export const GET_WALLET_BALANCE = "GET_WALLET_BALANCE";
export const GET_WALLET_BALANCE_FAIL = "GET_WALLET_BALANCE_FAIL";
export const GET_COMMISSION = "GET_COMMISSION";
export const MOVE_COMMISSION = "MOVE_COMMISSION";
export const MOVE_COMMISSION_FAIL = "MOVE_COMMISSION_FAIL";
export const GET_BONUS = "GET_BONUS";
export const GET_ALL_BONUS = "GET_ALL_BONUS";
export const GET_ALL_MANUAL = "GET_ALL_MANUAL";
export const GIVE_BONUS = "GIVE_BONUS";
export const GIVE_BONUS_FAIL = "GIVE_BONUS_FAIL";
export const MOVE_BONUS = "MOVE_BONUS";
export const MOVE_BONUS_FAIL = "MOVE_BONUS_FAIL";
export const TRANSFER_FUND = "TRANSFER_FUND";
export const TRANSFER_FUND_FAIL = "TRANSFER_FUND_FAIL";
export const ADD_FUND = "ADD_FUND";
export const ADD_FUND_FAIL = "ADD_FUND_FAIL";
export const FUND_WALLET = "FUND_WALLET";
export const FUND_WALLET_FAIL = "FUND_WALLET_FAIL";
export const UPDATE_WALLET = "UPDATE_WALLET";
export const UPDATE_WALLET_FAIL = "UPDATE_WALLET_FAIL";
export const SEARCH_WALLET = "SEARCH_WALLET";
export const SEARCH_WALLET_LOADING = "SEARCH_WALLET_LOADING";
export const SEARCH_WALLET_FAIL = "SEARCH_WALLET_FAIL";
export const SEARCH_WALLET_RELOAD = "SEARCH_WALLET_RELOAD";

export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_FAIL = "GET_ALL_USERS_FAIL";

export const GET_CARDS = "GET_CARDS";
export const GET_CARDS_FAIL = "GET_CARDS_FAIL";

export const GET_ALL_TRANSACTIONS = "GET_ALL_TRANSACTIONS";
export const GET_ALL_TRANSACTIONS_FAIL = "GET_ALL_TRANSACTIONS_FAIL";
export const GET_MY_TRANSACTIONS = "GET_MY_TRANSACTIONS";
export const GET_MY_TRANSACTIONS_FAIL = "GET_MY_TRANSACTIONS_FAIL";
export const SEARCH_TRANSACTION = "SEARCH_TRANSACTION";
export const SEARCH_TRANSACTION_LOADING = "SEARCH_TRANSACTION_LOADING";
export const SEARCH_TRANSACTION_FAIL = "SEARCH_TRANSACTION_FAIL";
export const SEARCH_TRANSACTION_RELOAD = "SEARCH_TRANSACTION_RELOAD";
export const SEARCH_MY_TRANSACTION = "SEARCH_MY_TRANSACTION";
export const SEARCH_MY_TRANSACTION_LOADING = "SEARCH_MY_TRANSACTION_LOADING";
export const SEARCH_MY_TRANSACTION_FAIL = "SEARCH_MY_TRANSACTION_FAIL";
export const SEARCH_MY_TRANSACTION_RELOAD = "SEARCH_MY_TRANSACTION_RELOAD";

export const GET_DATA_TRANSACTIONS = "GET_DATA_TRANSACTIONS";
export const GET_DATA_TRANSACTIONS_FAIL = "GET_DATA_TRANSACTIONS_FAIL";

export const GET_SETTINGS = "GET_SETTINGS";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_SETTINGS_FAIL = "UPDATE_SETTINGS_FAIL";

export const GET_NOTIFICATONS = "GET_NOTIFICATONS";
export const GET_NOTIFICATONS_FAIL = "GET_NOTIFICATONS_FAIL";
export const GET_MY_NOTIFICATONS = "GET_MY_NOTIFICATONS";
export const GET_MY_NOTIFICATONS_FAIL = "GET_MY_NOTIFICATONS_FAIL";
export const ADD_NOTIFICATONS = "ADD_NOTIFICATONS";
export const ADD_NOTIFICATONS_FAIL = "ADD_NOTIFICATONS_FAIL";
export const UPDATE_NOTIFICATONS = "UPDATE_NOTIFICATONS";

export const GENERATE_VIRTUAL = "GENERATE_VIRTUAL";
export const GENERATE_VIRTUAL_FAIL = "GENERATE_VIRTUAL_FAIL";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const GET_HONOUR_BALANCE = "GET_HONOUR_BALANCE";
export const GET_HONOUR_BALANCE_FAIL = "GET_HONOUR_BALANCE_FAIL";

export const SET_SUCCESS = "SET_SUCCESS";
export const SET_SUCCESS_FAIL = "SET_SUCCESS_FAIL";

export const GET_AIRTIME_CONVERTER = "GET_AIRTIME_CONVERTER";
export const GET_AIRTIME_CONVERTER_FAIL = "GET_AIRTIME_CONVERTER_FAIL";
export const ADD_AIRTIME_CONVERTER = "ADD_AIRTIME_CONVERTER";
export const ADD_AIRTIME_CONVERTER_FAIL = "ADD_AIRTIME_CONVERTER_FAIL";
export const GET_CONVERTER_NUMBER = "GET_CONVERTER_NUMBER";
export const GET_CONVERTER_NUMBER_FAIL = "GET_CONVERTER_NUMBER_FAIL";
export const ADD_CONVERTER_NUMBER = "ADD_CONVERTER_NUMBER";
export const ADD_CONVERTER_NUMBER_FAIL = "ADD_CONVERTER_NUMBER_FAIL";
export const UPDATE_CONVERTER_NUMBER = "UPDATE_CONVERTER_NUMBER";
export const UPDATE_CONVERTER_NUMBER_FAIL = "UPDATE_CONVERTER_NUMBER_FAIL";
export const UPDATE_CONVERTER_DETAIL = "UPDATE_CONVERTER__DETAIL";
export const UPDATE_CONVERTER_DETAIL_FAIL = "UPDATE_CONVERTER_DETAIL_FAIL";

export const ACTIVATE_USER = "ACTIVATE_USER";
export const ACTIVATE_USER_FAIL = "ACTIVATE_USER_FAIL";
